module.exports = __webpack_public_path__ + "static/media/alert.54efe7e9.svg";